import { fetchPersea } from "@/config/axios/config-axios";
import { UpdateUserProfileParams } from "./update-user-types";

export const updateUserProfile = async (params: UpdateUserProfileParams) => {
    return await fetchPersea(
        `/user`,
        'PUT',
        { wallet: params.wallet },
        params
    );
};